import { ForwardedRef, useEffect, useRef } from "react";
import { TimerSoundType } from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { useGlobalAudioContext } from "@contexts/GlobalAudioContext";

const AUDIO_SRC_ERROR_MSG = "Your browser does not support the audio tag.";

interface TimerAudioComponentProps {
    readonly alarmSound: TimerSoundType;
    readonly timerVolume: number;
    readonly timerAudioRef?: ForwardedRef<HTMLAudioElement>;
}
export default function TimerAudioComponent(props: TimerAudioComponentProps) {
    const localRef = useRef<HTMLAudioElement | null>(null);
    const { masterVolume } = useGlobalAudioContext();

    useEffect(() => {
        if (localRef?.current) {
            const volume = props.timerVolume * masterVolume;
            localRef.current.volume = volume;
        }
    }, [props.timerVolume, masterVolume]);

    return (
        <audio
            id={props.alarmSound.name}
            src={props.alarmSound.src}
            loop={false}
            controls={false}
            autoPlay={false}
            muted={props.timerVolume === 0}
            ref={(el) => {
                localRef.current = el;
                if (typeof props.timerAudioRef === "function") {
                    props.timerAudioRef(el);
                } else if (props.timerAudioRef != null) {
                    props.timerAudioRef.current = el;
                }
            }}
        >
            <source src={props.alarmSound.src} type="audio/mpeg" />
            {AUDIO_SRC_ERROR_MSG}
        </audio>
    );
}
